module.exports = __webpack_public_path__ + "static/media/Soul soffa 3-sits divan XL genisis lion miljö 2023 stående.e5bbb2e5.jpg";